// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mOOs","content":"styles_content__3BGvr"};